/* Stray bundles (devtools / overlays / extensions) sometimes reference `process` without webpack shims. */
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  window.process = { env: {} };
}
